import { AppShell } from '@/components/layout/AppShell';
import { PageHeader } from '@/components/shared/PageHeader';
import { ProfileSettingsPanel } from '@/components/profile/ProfileSettingsPanel';
import { useAuth } from '@/hooks/useAuth';
import { getLocalTimeZoneLabel } from '@/utils/date';

export function ProfilePage(): JSX.Element {
  const { profile } = useAuth();
  const timeZoneLabel = getLocalTimeZoneLabel();

  return (
    <AppShell>
      <PageHeader
        title="My Profile"
        description={`Discord identity and roster naming are shown in your local view. Times across the portal are displayed in ${timeZoneLabel}.`}
      />

      <ProfileSettingsPanel profile={profile} />
    </AppShell>
  );
}
